<template>
  <div class="mb-4 row">

    <div class="col-lg-12 col-md-12">
      <div class="card panel">
        <div class="card-header border-0">
          <div class="d-flex align-items-center">
            <h5 class="card-title mb-0 flex-grow-1">Orders List</h5>
            <div class="flex-shrink-0">
              <button class="btn btn-soft-danger" v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('delete-sales-order')" @click="deleteMultiple"><i class="ri-delete-bin-2-line"></i></button>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive product-create">
            <table class="table table-custom mb-0">
              <thead>
              <tr>
                <th scope="col" style="width: 40px;">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="checkAll" v-model="checkAllOrdersForDelete">
                  </div>
                </th>
                <th style="width: 140px">Order #</th>
                <th>Planned Delivery Date</th>
                <th>Customer</th>
                <th>Amount</th>

                <th>Created</th>
                <th>Updated</th>
                <th style="width: 180px;">Status</th>
                <th>Added By</th>
                <th style="width: 100px">Action</th>
              </tr>
              </thead>
              <template v-if="orderData.orders != null">
                <template v-for="(order, index) in orderData.orders.data">
                  <OrderListItem :bus="bus" :item="order" :id="index" @deleteItem="removeItem"
                                 @changeSelectedOrderForDelete="changeSelectedOrderForDelete"></OrderListItem>
                </template>
              </template>

            </table>

            <div class="btnrow text-left" v-if="orderData.orders != null && orderData.orders.data.length">
              <template>
                <div class="overflow-auto">
                  <b-pagination
                      v-model="current_page"
                      :total-rows="total"
                      :per-page="per_page"
                  ></b-pagination>
                </div>
              </template>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import OrderListItem from "./OrderListItem";
import Vue from "vue";

export default {
  name: "OrderList",
  props: ['search_filter', 'bus', 'is_draft', 'filterData'],
  components: {OrderListItem},
  created() {

  },
  mounted() {
    let self = this;
    if (this.filterData) {
      this.filterForm = this.filterData;
    }
    this.bus.$on('getOrders', () => {
      self.current_page = 1;
      self.getOrders(this);
    });

    this.bus.$on('resetOrderDeleteSelection', (event) => {
      this.selectedOrdersForDelete = [];
      this.checkAllOrdersForDelete = false;
    });

      this.getOrders();
  },
  data() {
    return {
      orderData: {
        orders: null,
        config: null,
      },
      current_page: 1,
      per_page: 10,
      total: 0,
      filterForm: {
        search_filter: null,
        status_search: null,
        sale_user_id: null,
        search_customer_id: null,
        search_added_user_id: null,
        search_by_date: null,
        date_range: null,
          label_id: null
      },
      selectedOrdersForDelete: [],
      checkAllOrdersForDelete: false
    }
  },
  methods: {
    ...mapActions([
      'setCommonErrors',
      'setErrorMessage',
      'setSuccessMessage',
      'setLoading'
    ]),
    selectOrder(c) {
      this.$emit('selectOrder', c)
    },
    removeItem(event) {
      this.$emit('deleteItem', event);
    },
    changeSelectedOrderForDelete(event) {
      if (this.selectedOrdersForDelete.includes(event.id)) {
        if (!event.checked) {
          this.selectedOrdersForDelete.splice(this.selectedOrdersForDelete.indexOf(event.id), 1);
        }
      } else {
        this.selectedOrdersForDelete.push(event.id);
      }
    },
    deleteMultiple() {
      if (this.selectedOrdersForDelete.length === 0) {
        Vue.$confirm({
          title: 'No order selected',
          message: 'Select at least one order.',
          button: {
            yes: 'Close',
          },
          callback: confirm => {
          }
        });
        return;
      }
      Vue.$confirm({
        title: 'Are you sure?',
        message: 'Are you sure you want to delete all selected orders?',
        button: {
          yes: 'Yes',
          no: 'Cancel'
        },
        callback: confirm => {
          if (confirm) {
            this.$emit('onDeleteMultiple', this.selectedOrdersForDelete);
          }

        }
      });

    },
    getOrders() {
      let self = this;
      this.setLoading(true);
      this.setCommonErrors([]);
      this.setErrorMessage(null);
      return axios.get(window.route('orders.index', {
        page: this.current_page,
        is_draft: this.is_draft ? this.is_draft : 0,
        search_filter: this.filterForm.search_filter,
        status_search: this.filterForm.status_search,
        sale_user_id: this.filterForm.sale_user_id,
        search_customer_id: this.filterForm.search_customer_id,
        search_added_user_id: this.filterForm.search_added_user_id,
        date_range: this.filterData.date_range,
        search_by_date: this.filterForm.search_by_date,
          label_id: this.filterForm.label_id,
      }), {

        validateStatus: function (status) {
          return status < 500; // Resolve only if the status code is less than 500
        }
      })
          .then(({data}) => {
            if (data.errors && data.errors.length) {
              self.setCommonErrors(data.errors);
            } else if (data.errorMessage) {
              self.setErrorMessage(data.errorMessage);
            } else {
              this.orderData = data.data;
              this.current_page = data.data.orders.current_page;
              this.per_page = data.data.orders.per_page;
              this.total = data.data.orders.total;

              this.$emit('returnTotalNumOrders', data.data.orders.total)
            }
          })
          .catch((error) => {
            self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

          })
          .finally(() => {
            self.setLoading(false);

          });
    },
  },
  watch: {
    current_page: {
      handler: function (value) {
          this.getOrders();
      }
    },
    search_filter: {
      handler: function (value) {
        this.filterForm.search_filter = value;
      }
    },
    filterData: {
      handler: function (value) {
        this.filterForm = value;
      }
    },
    checkAllOrdersForDelete: {
      handler: function (value) {
        this.bus.$emit('checkOrdersForDelete', value);
      }
    }
  },
  computed: {
    ...mapState([
      'userState'
    ]),
    ...mapGetters([
      'isAuth',
      'getAuthUser',
      'commonErrors',
      'errorMessage',
      'successMessage',
    ])
  }
}
</script>

<style scoped>

</style>
